import React from "react";

/**
 * Sales-order earmark display helpers (PO line -> sales order earmarks, 2026-09-03).
 *
 * The API derives earmarks from the tracking number's own PO + material at READ
 * time, so they show here even when the earmark was added after the material was
 * received -- exactly the case that motivated this (PO 1341, earmarked three hours
 * after receipt). `earmark_text` is the literal line the label prints.
 */

/** How one row of /material_tracking/{id}.earmarks should read. */
export function earmarkStateMeta(e) {
  switch (e?.state) {
    case "used":
      return { badge: "bg-secondary", text: `used (${e.consumed_quantity ?? 0} of ${e.quantity})` };
    case "released":
      return {
        badge: "bg-light text-dark border",
        text: e.released_at ? `released ${new Date(e.released_at).toLocaleDateString()}` : "released",
      };
    case "order_closed":
      return { badge: "bg-light text-dark border", text: "order closed" };
    default:
      return { badge: "bg-warning text-dark", text: "reserved · prints on the label" };
  }
}

/** `FOR: SO-1119 - Faith Technologies` -> a chip reading `SO-1119 - Faith Technologies`. */
export default function EarmarkChip({ text, className = "" }) {
  if (!text) return null;
  const body = String(text).replace(/^FOR:\s*/i, "");
  return (
    <span className={`badge bg-warning text-dark ${className}`} title={text}>
      <i className="bi bi-bookmark-fill me-1"></i>
      {body}
    </span>
  );
}
